import { defineStore } from 'pinia'
import { factory } from '../../../../factory-api/factory'

export const useUnsubscribeStore = defineStore('unsubscribe', () => {
  const unsubscribeDone = ref<boolean>(false)
  const showErrorMessage = ref<boolean>(false)
  const loading = ref<boolean>(false)

  const unsubscribe = async (candidateId: string) => {
    loading.value = true
    showErrorMessage.value = false
    unsubscribeDone.value = false

    const unsubscibeEmailRequest = { candidateId: candidateId }

    try {
      const jobMatchApi = await factory.getJobMatchApi()
      const response = await jobMatchApi.unsubscibeEmail(unsubscibeEmailRequest)

      if (response === true) {
        showErrorMessage.value = false
        unsubscribeDone.value = true
      } else {
        showErrorMessage.value = true
        unsubscribeDone.value = true
      }
    } catch (err) {
      console.warn('Error on unsubscribe: ', err)
      showErrorMessage.value = true
    } finally {
      loading.value = false
    }
  }

  return { unsubscribeDone, showErrorMessage, loading, unsubscribe }
})
